import React from "react";
import PropTypes from "prop-types";

export const NormalHeader = ({ children }) => {
  return (
    <h1 className="text-center text-black font-medium text-2xl mb-8 tracking-tight">
      {children}
    </h1>
  )
};

NormalHeader.propTypes = {
  children: PropTypes.node.isRequired,
};
